import { render, staticRenderFns } from "./ISPTickets.vue?vue&type=template&id=760dde74&"
import script from "./ISPTickets.vue?vue&type=script&lang=js&"
export * from "./ISPTickets.vue?vue&type=script&lang=js&"
import style0 from "./ISPTickets.vue?vue&type=style&index=0&id=760dde74&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports